import React from 'react';
import { DataTableV3Actions } from '../types';
import { Table } from '@tanstack/react-table';
import { Button, Icon } from '@innovationnorway/cl-react';

type PropType<TData extends object> = {
  actions: DataTableV3Actions<TData> | undefined;
  table: Table<TData> | undefined;
};

const PrimaryActions = <TData extends object>({ actions, table }: PropType<TData>) => {
  if (!table || !actions) {
    return <></>;
  }

  return (
    <div className="display--flex align-items--center gap--2">
      {actions?.primary?.map((action, index) => (
        <Button
          key={index}
          type="button"
          data-color={action.theme ?? 'primary'}
          variant={action.variant ?? 'primary'}
          onClick={() => {
            const rows = table.getSelectedRowModel().flatRows.map((row) => row.original);
            const resetSelected = action.onClick?.(rows);
            if (resetSelected === true) {
              table.toggleAllRowsSelected(false);
            }
          }}
        >
          {action.icon && <Icon {...action.icon} />}
          {action.label}
        </Button>
      ))}
    </div>
  );
};

export default PrimaryActions;
